import getGenerationErrorMessage from '@/utils/generation/getGenerationErrorMessage';
import sendGenerateFailureAnalytics from '@/utils/analytics/sendGenerateFailureAnalytics';
import { ToastType } from '@/store/toast/types';

import type { AnalyticsSettings } from '@/utils/analytics/analyticsSettings';
import type { IAppStore } from '@/store';

/**
 * Single error-handling helper for the `useGenerate` orchestrator. Wraps
 * the trio of side-effects we run when a submit or background poll fails:
 *  1. parse the error into a user-facing message + reason + type
 *  2. report a generation_failed analytics event
 *  3. transition the placeholder ContentFile into its error state
 *  4. surface a toast
 *
 * Both the synchronous submit branch and the background poll branch used
 * to duplicate this block — they share it now.
 */
const handleGenerationError = ({
  uuid,
  error,
  startTime,
  settings,
  updateContentFile,
  showToast,
}: {
  uuid: string;
  error: unknown;
  startTime: number;
  settings: AnalyticsSettings;
  updateContentFile: IAppStore['updateContentFile'];
  showToast: IAppStore['showToast'];
}) => {
  const { userMessage, reason, errorType } = getGenerationErrorMessage(error);
  sendGenerateFailureAnalytics(
    Date.now() - startTime,
    settings,
    `Generation: ${reason}`
  );
  updateContentFile({
    uuid,
    updates: {
      isLoading: false,
      error: userMessage,
      errorType,
      generationStartTime: undefined,
    },
  });
  showToast(userMessage, ToastType.Error);
};

export default handleGenerationError;
